export default __webpack_public_path__ + "static/media/avatar.be85e7b2.svg";